module.exports = __webpack_public_path__ + "static/img/huaweiMateBookX.7f75a23f.png";